<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import type {Attendee} from "@shared/Types.ts";

    const dispatch = createEventDispatcher<{ 'remove': undefined, 'change': Attendee }>();

    export let attendee: Attendee = {} as Attendee;

    function d() {
        console.log('change', attendee.firstName)
        dispatch('change', attendee)
    }
</script>

<tr>
    <td><button on:click={() => dispatch('remove')} class="outline">X</button></td>
    <td><input type='text' bind:value={attendee.lastName} placeholder="Last Name" on:change={d}/></td>
    <td><input type='text' bind:value={attendee.firstName} placeholder="First Name" on:change={d}/></td>
    <td>
        <select bind:value={attendee.ageOnApril24} on:change={d}>
            <option value="" disabled>Select age</option>
            {#each Array.from({length: 18}, (_, i) => i) as age}
                <option value={age.toString()}>{age}</option>
            {/each}
            <option value="18 or over">18 or over</option>
        </select>
    </td>
    {#if attendee.ageOnApril24 === '18 or over'}
        <td></td>
        <td></td>
    {:else}
        <td><label><input type="checkbox" bind:checked={attendee.registeredForRE} on:change={d}/></label></td>
        <td><input bind:value={attendee.responsibleAdult} placeholder="Responsible Adult" on:change={d}/></td>
    {/if}
    <td><label><input type="checkbox" bind:checked={attendee.okToPhotograph} on:change={d}/></label></td>
    <td><label><input type="checkbox" bind:checked={attendee.vegetarian} on:change={d}/></label></td>
    <td><label><input type="checkbox" bind:checked={attendee.vegan} on:change={d}/></label></td>
    <td><label><input type="checkbox" bind:checked={attendee.glutenFree} on:change={d}/></label></td>
    <td><label><input type="checkbox" bind:checked={attendee.dairyFree} on:change={d}/></label></td>
</tr>

<style>
    input, select {
        margin-bottom: 0;
    }

    input[type='text'], select {
        width: 200px;
    }
</style>